module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/cambridge-c8081579d17ec869c0d862c78df81e7e.svg";